import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { WebappService } from '../../services/webapp.service';

@Component({
  selector: 'mobo-coupon-list',
  templateUrl: './coupon-list.component.html',
  styles: [],
})
export class CouponListComponent implements OnInit, OnDestroy {
  @Input() listTitle?: string;
  @Input() campaigns?: any[] | null;
  @Input() showButton = true;
  @Output() seeAll = new EventEmitter();
  public isLoading = false;
  private $isLoading!: Subscription;

  constructor(public webappService: WebappService) {}

  ngOnInit() {
    this.isLoading = this.webappService.isLoading.value;
    this.whatchIsLoading();
  }

  ngOnDestroy() {
    this.$isLoading.unsubscribe();
  }

  whatchIsLoading() {
    this.$isLoading = this.webappService.isLoading.subscribe((val) => {
      this.isLoading = val;
    });
  }

  public emitSeeAll() {
    this.seeAll.emit();
  }
}
